import { Checkbox } from 'antd';
import ConfigProviderCheckbox from './CheckboxConfigProvider';

const GNECheckbox = ({ checked, onChange, disabled, label, wrapperCss }) => {
  return (
    <ConfigProviderCheckbox>
      <div className={`d-flex align-items-center ${wrapperCss}`}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}>
          {label && (
            <label
              className={
                disabled ? 'checkbox-label-disabled' : 'checkbox-label'
              }>
              {label}
            </label>
          )}
        </Checkbox>
      </div>
    </ConfigProviderCheckbox>
  );
};

export default GNECheckbox;
